import $ from 'jquery';
import { LinkHTMLAttributes } from "react";
import { useNavigate } from "react-router-dom";

type Props = LinkHTMLAttributes<any> & {
    isDropdown?: boolean,
    state?: { [x: string]: any }
}

export default function Link(props: Props) {
    const navigate = useNavigate();
    const { isDropdown = false, href, state } = props;

    let linkProps = { ...props, state: undefined };
    delete linkProps.isDropdown;

    return <a {...linkProps} onClick={e => {
        props?.onClick && props?.onClick(e);
        if (!isDropdown && (!href || href.substring(0, 1) !== '#')) {
            const href = $(e.currentTarget).attr('href');
            e.preventDefault()
            navigate(href ?? '#', { state });
        }
    }}>{props.children}</a>
}